import { render, staticRenderFns } from "./ProcessFrequencyTiles.vue?vue&type=template&id=4889083c&scoped=true&"
import script from "./ProcessFrequencyTiles.vue?vue&type=script&lang=js&"
export * from "./ProcessFrequencyTiles.vue?vue&type=script&lang=js&"
import style0 from "./ProcessFrequencyTiles.vue?vue&type=style&index=0&id=4889083c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889083c",
  null
  
)

export default component.exports